"use client";

import * as Sentry from "@sentry/nextjs";
import {useEffect} from "react";
import {useTranslations} from "next-intl";
import AppLogo from "@/app/components/common/app-logo/AppLogo";
import {MainCtaBtn} from "@/app/components/common/main-cta-btn/MainCtaBtn";

interface IProps {
    error: Error & {digest?: string};
    reset: () => void;
}

// AC-883: without a boundary on this segment every client render error escaped
// to app/global-error.tsx, which swaps the whole <html> for Next's default page
// ("Application error: a client-side exception has occurred") — that is what a
// player reported on aldex.win. The crashes we see are transient render races,
// so reset() re-renders the segment and usually puts them straight back.
export default function LocaleError({error, reset}: IProps) {
    const t = useTranslations('Errors');

    useEffect(() => {
        Sentry.captureException(error);
    }, [error]);

    return (
        <div className={'bg-dark-gray min-h-screen flex items-center justify-center px-[16px] py-[64px]'}>
            <div className={'flex flex-col items-center max-w-[415px] w-full'}>
                <AppLogo className={'w-[128px] h-[123px] mb-[36px]'}/>
                <h1 className={'text-white text-[24px] font-semibold text-center mb-[12px]'}>
                    {t('somethingWentWrong')}
                </h1>
                <p className={'text-noble-black-300 text-[14px] text-center mb-[36px]'}>
                    {t('pleaseTryAgainLater')}
                </p>
                <MainCtaBtn onClick={() => reset()} className={'w-full h-[51px] text-[16px] mb-[12px]'}>
                    {t('tryAgain')}
                </MainCtaBtn>
                <MainCtaBtn href={'/'} className={'w-full h-[51px] text-[16px]'}>
                    {t('backToLobby')}
                </MainCtaBtn>
            </div>
        </div>
    );
}
